<template>
  <teleport to="body">
    <transition name="modal-fade">
      <div v-if="visible" class="modal-overlay" @click.self="close">
        <div class="modal-box">
          <div class="modal-header" v-if="title">
            <span class="modal-title">{{ title }}</span>
            <span class="modal-close" @click="close">&times;</span>
          </div>
          <div class="modal-body">
            <slot />
          </div>
          <div class="modal-footer" v-if="$slots.footer">
            <slot name="footer" />
          </div>
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script>
export default {
  name: 'ModalBox',
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    closeOnOverlay: { type: Boolean, default: true }
  },
  emits: ['close'],
  methods: {
    close() {
      if (this.closeOnOverlay) {
        this.$emit('close');
      }
    }
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.modal-box {
  background: #fff;
  border-radius: 14px;
  width: 85%;
  max-width: 340px;
  overflow: hidden;
  box-shadow: 0 12px 40px rgba(0,0,0,0.15);
}
.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 18px 12px;
}
.modal-title {
  font-size: 17px;
  font-weight: 600;
  color: #1a1a1a;
}
.modal-close {
  font-size: 24px;
  color: #999;
  cursor: pointer;
  line-height: 1;
}
.modal-body {
  padding: 0 18px 18px;
  font-size: 15px;
  color: #333;
  line-height: 1.6;
}
.modal-footer {
  padding: 0 18px 16px;
  display: flex;
  gap: 10px;
  justify-content: flex-end;
}

.modal-fade-enter-active { transition: opacity 0.25s ease; }
.modal-fade-leave-active { transition: opacity 0.2s ease; }
.modal-fade-enter-from,
.modal-fade-leave-to { opacity: 0; }
</style>
